module.exports = __webpack_public_path__ + "img/app-logo.aba3a080.png";